import React from 'react'

interface ModalProps { onClose: () => void; children: React.ReactNode; maxWidth?: string; style?: React.CSSProperties }

export const Modal: React.FC<ModalProps> = ({ onClose, children, maxWidth = '480px', style }) => (
  <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', animation: 'modalFadeIn 0.15s ease' }}>
    <style>{`@keyframes modalFadeIn { from { opacity: 0 } to { opacity: 1 } } @keyframes modalSlideIn { from { opacity: 0; transform: translateY(10px) } to { opacity: 1; transform: translateY(0) } }`}</style>
    <div onClick={(e) => e.stopPropagation()} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '16px', padding: '1.75rem', width: '100%', maxWidth, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 16px 48px rgba(0,0,0,0.35)', animation: 'modalSlideIn 0.2s ease', ...style }}>
      {children}
    </div>
  </div>
)
